import React from "react";
import InputMask from "react-input-mask";
import {
  FormField,
  FormInput,
  FormRow,
  FormRow2,
  RemoveButton,
  SearchCPFBar,
  SearchCPFContainer,
  SearchIcon,
} from "../styles/ChoosePlan";
import { getContractAssociatedInfo } from "../data/services/crew_service";
import LimitedRelationshipModel from "../data/models/limitedRelationship";

interface DependentProps {
  index: number;
  dependent: {
    nome: string;
    telefone: string;
    cpf: string;
    email: string;
    relationship: string;
  };
  onRemove: (index: number) => void;
  onChange: (index: number, field: string, value: string) => void;
  relationships: LimitedRelationshipModel[];
}

const Dependent2: React.FC<DependentProps> = ({
  index,
  dependent,
  onRemove,
  onChange,
  relationships,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    let sanitized = value;

    if (name === "cpf" || name === "telefone") {
      sanitized = value.replace(/\D/g, "");
    }

    onChange(index, name, sanitized);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    onChange(index, name, value);
  };

  const handleSearchClick = async () => {
    const cpf = dependent.cpf.replace(/\D/g, "");

    if (!cpf || cpf.length !== 11) {
      alert("Por favor, insira um CPF válido.");
      return;
    }

    try {
      const { contract } = await getContractAssociatedInfo(cpf);

      if (contract) {
        onChange(index, "nome", contract.nome || "");
        onChange(index, "telefone", contract.telefoneEmp || "");
        onChange(index, "email", contract.emailCob || "");
      } else {
        alert("Nenhum contrato associado encontrado.");
      }
    } catch (error) {
      console.error("Erro ao buscar contrato:", error);
      alert("Erro ao buscar informações.");
    }
  };

  return (
    <>
      <FormField>
        <FormRow2>
          <h1>Dependente {index + 1}</h1>
          <RemoveButton onClick={() => onRemove(index)}>x</RemoveButton>
        </FormRow2>

        <SearchCPFContainer>
          <InputMask
            mask="99999999999"
            value={dependent.cpf}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <SearchCPFBar {...inputProps} name="cpf" placeholder="CPF" />
            )}
          </InputMask>

          <SearchIcon size={20} onClick={handleSearchClick} />
        </SearchCPFContainer>
      </FormField>

      <FormRow>
        <FormField>
          <InputMask
            mask="(99) 99999-9999"
            value={dependent.telefone}
            onChange={handleInputChange}
          >
            {(inputProps: any) => (
              <FormInput
                {...inputProps}
                type="tel"
                name="telefone"
                placeholder="Telefone"
              />
            )}
          </InputMask>
        </FormField>

        <FormField>
          <select
            name="relationship"
            value={dependent.relationship}
            onChange={handleSelectChange}
          >
            <option value="" disabled>
              Grau de Parentesco
            </option>
            {relationships.map((item) => (
              <option
                key={item.id_parentesco ?? ""}
                value={item.id_parentesco ?? ""}
              >
                {item.parentesco}
              </option>
            ))}
          </select>
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <FormInput
            type="text"
            name="nome"
            placeholder="Nome Completo"
            value={dependent.nome}
            onChange={handleInputChange}
          />
        </FormField>

        <FormField>
          <FormInput
            type="email"
            name="email"
            placeholder="E-mail"
            value={dependent.email}
            onChange={handleInputChange}
          />
        </FormField>
      </FormRow>
    </>
  );
};

export default Dependent2;
